import { TacticInclusionState, TACTIC_INCLUSION_META } from '@models/index'
import './TacticInclusionToggle.css'

interface TacticInclusionToggleProps {
  value: TacticInclusionState
  onChange: (state: TacticInclusionState) => void
  disabled?: boolean
  size?: 'small' | 'medium'
  showLabels?: boolean
}

const INCLUSION_ORDER: TacticInclusionState[] = ['included', 'maybe', 'excluded']

export function TacticInclusionToggle({
  value,
  onChange,
  disabled = false,
  size = 'small',
  showLabels = false
}: TacticInclusionToggleProps) {
  return (
    <div
      className={`inclusion-toggle ${size} ${disabled ? 'disabled' : ''}`}
      role="radiogroup"
      aria-label="Tactic inclusion state"
    >
      {INCLUSION_ORDER.map(state => {
        const meta = TACTIC_INCLUSION_META[state]
        const isSelected = value === state

        return (
          <button
            key={state}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={`inclusion-btn ${state} ${isSelected ? 'selected' : ''}`}
            onClick={() => !disabled && onChange(state)}
            disabled={disabled}
            title={meta.description}
            style={{ '--inclusion-color': meta.color } as React.CSSProperties}
          >
            <span className="inclusion-icon">{meta.icon}</span>
            {showLabels && <span className="inclusion-label">{meta.label}</span>}
          </button>
        )
      })}
    </div>
  )
}

export default TacticInclusionToggle
